import { render, staticRenderFns } from "./twofactor-disable.vue?vue&type=template&id=465d5ec8&scoped=true"
import script from "./twofactor-disable.vue?vue&type=script&lang=ts"
export * from "./twofactor-disable.vue?vue&type=script&lang=ts"
import style0 from "./twofactor-disable.vue?vue&type=style&index=0&id=465d5ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d5ec8",
  null
  
)

export default component.exports